import { render } from "./QuestionWeight.vue?vue&type=template&id=072c56f2&scoped=true"
import script from "./QuestionWeight.vue?vue&type=script&lang=js"
export * from "./QuestionWeight.vue?vue&type=script&lang=js"

import "./QuestionWeight.vue?vue&type=style&index=0&id=072c56f2&scoped=true&lang=css"

import exportComponent from "/home/stagging/consillium/front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-072c56f2"]])

export default __exports__